<template>
    <div>
        <div class="input-group">
            <select @change="createDate" v-model="manualDate.year" name="year" :class="{ 'is-invalid': error }"
                class="form-select">
                <option disabled value="">Year</option>
                <option v-for="(year, yIndex) in years" :key="yIndex" :value="year.value">{{ year.label }}</option>
            </select>
            <select @change="createDate" v-model="manualDate.month" name="month" :class="{ 'is-invalid': error }"
                class="form-select">
                <option disabled value="">Month</option>
                <option v-for="(month, mIndex) in months" :key="mIndex" :value="month.value">{{ month.label }}</option>
            </select>
            <select @change="createDate" v-model="manualDate.day" name="day" :class="{ 'is-invalid': error }"
                class="form-select">
                <option disabled value="">Day</option>
                <option v-for="(day, dIndex) in days" :key="dIndex" :value="day.value">{{ day.label }}</option>
            </select>
        </div>
    </div>
</template>


<script>
export default {
    name: "CommonDatePicker",
    props: {
        modelValue: String,
        error: Boolean,
        minDate: {
            type: Date,
            default: () => {
                const date = new Date();
                date.setFullYear(date.getFullYear() - 100);
                return date;
            },
        },
        maxDate: {
            type: Date,
            default: () => {
                const date = new Date();
                date.setFullYear(date.getFullYear() + 100);
                return date;
            },
        },
    },
    data() {
        return {
            manualDate: {
                day: "",
                month: "",
                year: "",
            },
        };
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(val) {
                if (val) {
                    const date = new Date(val);
                    this.manualDate.day = date.getDate();
                    this.manualDate.month = date.getMonth() + 1;
                    this.manualDate.year = date.getFullYear();
                }
            },
        },
    },
    computed: {
        years() {
            const minYear = this.minDate.getFullYear();
            const maxYear = this.maxDate.getFullYear();

            return Array.from({ length: maxYear - minYear + 1 }, (_, i) => {
                const year = maxYear - i;
                return { value: year, label: String(year) };
            });
        },
        months() {
            const selectedYear = this.manualDate.year;
            let start = 1;
            let end = 12;

            if(!selectedYear) return [];

            if (selectedYear == this.minDate.getFullYear()) start = this.minDate.getMonth() + 1;
            if (selectedYear == this.maxDate.getFullYear()) end = this.maxDate.getMonth() + 1;

            const names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            return Array.from({ length: end - start + 1 }, (_, i) => {
                const value = start + i;
                return { value, label: names[value - 1] };
            });
        },
        days() {
            const { year, month } = this.manualDate;
            if (!year || !month) return [];

            const daysInMonth = new Date(year, month, 0).getDate();

            let start = 1;
            let end = daysInMonth;

            if (year == this.minDate.getFullYear() && month == this.minDate.getMonth() + 1) {
                start = this.minDate.getDate();
            }

            if (year == this.maxDate.getFullYear() && month == this.maxDate.getMonth() + 1) {
                end = this.maxDate.getDate();
            }

            return Array.from({ length: end - start + 1 }, (_, i) => {
                const value = start + i;
                return {
                    value,
                    label: String(value).padStart(2, "0"),
                };
            });
        },
    },
    methods: {
        createDate() {
            const { day, month, year } = this.manualDate;

            if (!day || !month || !year) {
                this.$emit("update:modelValue", "");
                return;
            }

            const date = new Date(year, month - 1, day);

            if (date < this.minDate || date > this.maxDate) {
                this.$emit("update:modelValue", "");
                return;
            }

            const formatted = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
            this.$emit("update:modelValue", formatted);
        },
    },
};
</script>
